import React, { Component, Fragment } from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { auth } from '../config/firebase';
import './App.css';
// **************** Actions **********************
import { signOut } from '../store/actions/authActions';
import { clearUserData } from '../store/actions/userActions';
import { clearSale } from '../store/actions/saleActions';
import { clearSeller } from '../store/actions/sellerActions';
// **************** COMPONENTS ********************
import Dashboard from '../components/Dashboard/Dashboard';
import ErrorPage from '../components/ErrorPage/ErrorPage.jsx';
// --------------- Analytics -------------------
import Analytics from '../components/Analytics/Analytics';
// --------------- Currency -------------------
import Currency from '../components/Currency/Currency';
// --------------- Products -------------------
import NewProduct from '../components/Products/NewProduct/NewProduct';
import EditProduct from '../components/Products/EditProduct/EditProduct';
import ProductDetails from '../components/Products/ProductDetails/ProductDetails';
import Products from '../components/Products/Products';
import SideBar from '../components/SideBar/Sidebar';
// --------------- Inventory Count -------------------
import InventoryCount from '../components/InventoryCount/InventoryCount';
import NewInventory from '../components/InventoryCount/NewInventory/NewInventory';
// --------------- Sales -------------------
import Sales from '../components/Sales/Sales';
import NewSale from '../components/Sales/NewSale/NewSale';
import EditSale from '../components/Sales/EditSale/EditSale';
import SaleDetails from '../components/Sales/SaleDetails/SaleDetails';
// --------------- Sellers -------------------
import Sellers from '../components/Sellers/Sellers';
import NewSeller from '../components/Sellers/NewSeller/NewSeller';
import EditSeller from '../components/Sellers/EditSeller/EditSeller';
// --------------- Search -------------------
import SearchBar from '../components/SearchBar/SearchBar';
import SearchList from '../components/SearchBar/SearchList';
import Notifications from '../components/Notifications/Notifications';

// --------------- Scanner -------------------
import Scanner from '../components/Scanner/Scanner';

// --------------- Payments -------------------
import Payments from '../components/Payments/Payments';
// --------------- Expenses -------------------
import Expenses from '../components/Expenses/Expenses';
import AddExpense from '../components/Expenses/AddExpense/AddExpense';
import ExpenseDetails from '../components/Expenses/ExpenseDetails/ExpenseDetails';
import EditExpense from '../components/Expenses/EditExpense/EditExpense';
// --------------- Auth -------------------
import SignIn from '../components/Auth/SignIn';
import SignUp from '../components/Auth/SignUp';
// --------------- Users -------------------
import User from '../components/User/User';
import Settings from '../components/Settings/Settings';

class App extends Component {

	signOutHandler = () => {
		auth.signOut();
		this.props.signOut();
		this.props.clearUserData();
		this.props.clearSale();
		this.props.clearSeller();
		window.localStorage.clear();
		this.props.history.replace('/sign-in');
	}

	render() {
		// User language
		const { user: { lang = "en" }, auth: { isAdmin, isLogged } } = this.props;
		if (!isLogged) {
			return (
				<Fragment>
					<Switch>
						<Route path={["/", '/sign-in']} exact component={SignIn} />
						<Route path="/sign-up" exact component={SignUp} />
						<Route component={SignIn} />
					</Switch>
				</Fragment>
			)
		} else {
			if (isLogged && isAdmin) {
				return (
					<main className={`${this.props.user.theme || 'default'}`}>
						<SideBar lang={lang} signout={this.signOutHandler} />
						<section className="main-content" id="main-section">
							<SearchBar lang={lang} />
							<div className="container">
								<Switch>
									{
										['/sign-in', '/sign-up'].map((item) => {
											return <Redirect from={item} exact to="/" key={item} />
										})
									}
									<Route path="/" exact lang={lang} component={Dashboard} />
									<Route path="/analytics" exact lang={lang} component={Analytics} />
									<Route path="/currency" exact lang={lang} component={Currency} />
									<Route path="/settings" exact lang={lang} component={Settings} />

									<Route path="/sales" exact lang={lang} component={Sales} />
									<Route path="/sales/:id/sale" exact lang={lang} component={NewSale} />
									<Route path="/sales/:id/edit" exact lang={lang} component={EditSale} />
									<Route path="/sales/:id" exact lang={lang} component={SaleDetails} />

									<Route path="/sellers" exact lang={lang} component={Sellers} />
									<Route path="/sellers/new" exact lang={lang} component={NewSeller} />
									<Route path="/sellers/:id/edit" exact lang={lang} component={EditSeller} />

									<Route path="/products" exact lang={lang} component={Products} />
									<Route path="/products/:id" exact lang={lang} component={ProductDetails} />
									<Route path="/products/:id/edit" exact lang={lang} component={EditProduct} />
									<Route path="/new-product" exact lang={lang} component={NewProduct} />

									<Route path="/payments" exact lang={lang} component={Payments} />

									<Route path="/notifications" exact lang={lang} component={Notifications} />
									<Route path="/inventory-count" exact lang={lang} component={InventoryCount} />
									<Route path="/inventory-count/new" exact lang={lang} component={NewInventory} />
									<Route path="/search-result" exact lang={lang} component={SearchList} />
									<Route path="/scanner" exact lang={lang} component={Scanner} />

									<Route path="/expenses" exact lang={lang} component={Expenses} />
									<Route path="/expenses/new" exact lang={lang} component={AddExpense} />
									<Route path="/expenses/:id" exact lang={lang} component={ExpenseDetails} />
									<Route path="/expenses/:id/edit" exact lang={lang} component={EditExpense} />

									<Route path="/profile" exact lang={lang} render={(props) => <User {...props} signout={this.signOutHandler} />} />
									<Route component={ErrorPage} />
								</Switch>
							</div>

						</section>
					</main>
				);
			} else {
				return (
					<main className={`${this.props.user.theme || 'dark-theme'}`}>
						<SideBar signout={this.signOutHandler} />
						<section className="main-content" id="main-section">
							<SearchBar />
							<div className="container">
								<Switch>
									{
										['/sign-in', '/sign-up'].map((item) => {
											return <Redirect from={item} exact lang={lang} to="/" key={item} />
										})
									}
									<Route path="/sales" exact lang={lang} component={Sales} />
									<Route path="/sales/:id/sale" exact lang={lang} component={NewSale} />
									<Route path="/sales/:id/edit" exact lang={lang} component={EditSale} />
									<Route path="/sales/:id" exact lang={lang} component={SaleDetails} />

									<Route path="/products" exact lang={lang} component={Products} />
									<Route path="/products/:id" exact lang={lang} component={ProductDetails} />

									<Route path="/search-result" exact lang={lang} component={SearchList} />
									<Route path="/scanner" exact lang={lang} component={Scanner} />

									<Route component={ErrorPage} />
								</Switch>
							</div>

						</section>
					</main>
				)
			}

		}
	}
}

const mapStateToProps = state => {
	return {
		auth: state.auth,
		user: state.user,
		products: state.products,
		// sales: state.sales
	}
}

const mapDispatchToProps = dispatch => {
	return {
		clearUserData: () => dispatch(clearUserData()),
		clearSale: () => dispatch(clearSale()),
		clearSeller: () => dispatch(clearSeller()),
		signOut: () => dispatch(signOut()),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
